module.exports = __webpack_public_path__ + "static/media/Logo.43b6276a.png";